/** The `shippingAddressSnapshot`/delivery-address jsonb column has no enforced shape at the type level (it's a point-in-time copy, schema-independent by design) -- this reads the fields every address snapshot in this codebase actually has (see AddressRow) defensively, falling back gracefully rather than crashing on an unexpected shape. */
export interface ParsedAddressSnapshot {
  recipientName: string | null;
  phone: string | null;
  line1: string | null;
  line2: string | null;
  landmark: string | null;
  city: string | null;
  state: string | null;
  pincode: string | null;
}

function stringField(value: unknown): string | null {
  return typeof value === 'string' && value.length > 0 ? value : null;
}

export function parseAddressSnapshot(snapshot: unknown): ParsedAddressSnapshot {
  const record = typeof snapshot === 'object' && snapshot !== null ? (snapshot as Record<string, unknown>) : {};
  return {
    recipientName: stringField(record.recipientName),
    phone: stringField(record.phone),
    line1: stringField(record.line1),
    line2: stringField(record.line2),
    landmark: stringField(record.landmark),
    city: stringField(record.city),
    state: stringField(record.state),
    pincode: stringField(record.pincode),
  };
}

export function formatAddressLines(snapshot: unknown): string[] {
  const parsed = parseAddressSnapshot(snapshot);
  const lines: string[] = [];
  if (parsed.recipientName) lines.push(parsed.recipientName);
  if (parsed.line1) lines.push(parsed.line1);
  if (parsed.line2) lines.push(parsed.line2);
  if (parsed.landmark) lines.push(parsed.landmark);
  const cityLine = [parsed.city, parsed.state, parsed.pincode].filter(Boolean).join(', ');
  if (cityLine) lines.push(cityLine);
  if (parsed.phone) lines.push(parsed.phone);
  return lines;
}
